/**
 * Application Constants
 * 
 * Global constants for app name, version, and metadata.
 * Change these values to update across the entire application.
 */

export const APP_NAME = 'EmberBoard';
export const APP_VERSION = '0.3.0-alpha';
export const APP_DESCRIPTION = 'Node-based storyboard development software for fast story creation';
export const APP_AUTHOR = 'Gnomelight';
export const APP_COPYRIGHT = `© ${new Date().getFullYear()} ${APP_AUTHOR}`;

/**
 * File extension for project files
 */
export const PROJECT_EXTENSION = 'emberboard';

/**
 * Full app title with version
 */
export const APP_TITLE = `${APP_NAME} ${APP_VERSION}`;

/**
 * Performance limits for web version
 * Warning at 200 beats (~10 min at 3s/beat)
 * Hard cap at 300 beats (~15 min at 3s/beat)
 */
export const NODE_WARNING_COUNT = 200;
export const NODE_MAX_COUNT = 300;

/**
 * Analytics configuration
 * Privacy-focused usage tracking via Cloudflare Workers
 */
export const ANALYTICS_ENABLED = true;
export const ANALYTICS_ENDPOINT = 'https://emberboard-stats.daniel-joensson.workers.dev/track';
